





import { defineComponent } from '@vue/composition-api';

const Router = defineComponent({
  // setup() {},
});

export default Router;
